// extracted by mini-css-extract-plugin
export default {"alfa":"SensorType_alfa__2mCGk","btadd":"SensorType_btadd__wfVug","creer":"SensorType_creer__8n8PQ"};